import {contractApi} from "@/axios";

export function getProjectList(data){
    return contractApi({
        url:'/project-manage/main-type/list',
        method:'post',
        data:data
    })
}
//获取合同项目状态
export function getProjectStatus(id){
    return contractApi({
        url:'/project-manage/main-type/get-status/' + id,
        method:'get',
    })
}